import {OPENING_SURVEY} from './CancelUrlContants';

export const launchOpinionLab = (event) => {
    try {
        window.launchOpinionLabSurvey('CreditAppExit', event);
    } catch (err) {
        window.capeLog && window.capeLog(`launchOpinionLabSurvey:us:error:${err}`);
    }
    return {
        type: OPENING_SURVEY
    };

};
